// extracted by mini-css-extract-plugin
export default {"controls":"WagonsPageHeaderComponent_controls__hsUPA"};